<template>
    <modal @close="closeRegistrationModal" :width="modalWidth">
        <h3 v-if="!demo.isDemo && team.plan!='pro'">Upgrade Your Plan</h3>
        <h3 v-else>Sign Up To Bookblock HUB</h3>
        
        <h4 v-if="step=='start'">Please Choose Your Bookblock HUB Plan</h4>
        <h4 v-if="step=='form'">Please Enter Your Details</h4>
        <div v-if="step=='start'" class="large-form" id="worksends-registration-step-1">
            <div v-if="!demo.isDemo && $store.state.proBlockMessage" class="small-note warning" style="max-width: 470px"><span>UPGRADE REQUIRED:</span> <b>{{ $store.state.proBlockMessage }}</b> is only available with <b>Bookblock HUB Pro</b> plan. Please upgrade your account to continue.</div>
            <div id="worksends-plans">
                <div class="worksends-plan plan-on-demand">
                    <h3>Bookblock HUB <span>On Demand</span></h3>
                    <ul class="worksends-plan-points">
                        <li class="positive"><b>Bookblock HUB Marketplace</b> for on demand gifting of more than 100 curated gifts</li>
                        <li class="negative">No Bookblock HUB Campaigns</li>
                        <li class="negative">No corporate products</li>
                        <li class="negative">No access to Surveys</li>
                        <li class="negative">No access to Audience</li>
                        <li class="negative">Limited to direct card payments</li>
                        <li class="negative">Limited to one user per team</li>
                    </ul>
                    <div class="worksends-plan-price">Always Free</div>
                    <div class="worksends-plan-note">Pay as you go for on demand Marketplace sends. You can always upgrade to Bookblock HUB Pro after you sign up.</div>
                    <div v-if="!demo.isDemo && team.plan && team.plan!='pro'" class="worksends-plan-current">Your Current Plan</div>
                    <div v-else class="ws-button" @click="chooseAccountPlan('free')">CONTINUE WITH ON DEMAND</div>
                </div>
                <div class="worksends-plan plan-pro">
                    <h3>Bookblock HUB <span>Pro</span></h3>
                    <ul class="worksends-plan-points">
                        <li class="positive">Unlimited use of <b>Bookblock HUB Marketplace</b></li>
                        <li class="positive"><b>Bookblock HUB Campaigns</b> (onboarding, seasonal or any structured & planned gifting)</li>
                        <li class="positive"><b>Bespoke Products</b> hosted in our warehouse</li>
                        <li class="positive"><b>Bookblock HUB Surveys</b></li>
                        <li class="positive"><b>Bookblock HUB Audience</b></li>
                        <li class="positive">Use your team balance or pay directly</li>
                        <li class="positive">Unimited team members</li>
                    </ul>
                    <div class="worksends-plan-price">Variable Pricing</div>
                    <div class="worksends-plan-note">Depending on your team size & needs. A Bookblock HUB representative will get in touch with you soon after you sign up.</div>
                    <div v-if="!demo.isDemo && team.plan!='pro'" class="ws-button ws-button-main" @click="chooseAccountPlan('trial')">UPGRADE TO BOOKBLOCK HUB PRO</div>
                    <div v-else class="ws-button ws-button-main" @click="chooseAccountPlan('trial')">INTERESTED IN BOOKBLOCK HUB PRO</div>
                </div>
            </div>
        </div>
        <div v-if="step=='form'" class="large-form" id="worksends-registration-step-2">
            <div class="form-line">
                <div class="form-field">
                    <label>Your Full Name</label>
                    <input v-model="form.name" required>
                </div>
            </div>
            <div class="form-line">
                <div class="form-field">
                    <label>Company / Team Name</label>
                    <input v-model="form.teamName" required>
                </div>
            </div>
            <div class="form-line">
                <div class="form-field">
                    <label>Your Email</label>
                    <input v-model="form.email" type="email" required>
                </div>
            </div>
            <div class="form-line">
                <div class="form-field" style="width: 50%">
                    <label>Password</label>
                    <input v-model="form.password" type="password" required>
                </div>
                <div class="form-field" style="width: 50%">
                    <label>Confirm Password</label>
                    <input v-model="form.passwordConfirm" type="password" required>
                </div>
            </div>            
            <div class="form-line" v-if="form.accountPlan=='free'">
                <div class="form-field">
                    <label>How Did You Hear About Us?</label>
                    <select v-model="form.reference" required>
                        <option value="">-- Please choose one option --</option>
                        <option value="Google">Google / Internet Search</option>
                        <option value="Social Media">Social Media</option>
                        <option value="Bookblock HUB Contact">Contacted By Bookblock HUB Representative</option>
                        <option value="Personal Reference">Personal Reference</option>
                        <option value="Other">Other</option>
                    </select>
                </div>
                <div class="form-field" v-if="form.reference == 'Other'">
                    <input v-model="form.referenceOther" placeholder="Please specify...">
                </div>
             </div>
             
             <div class="modal-errors">
                 <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
             </div>
             
             <div class="form-line">
                 <div class="form-field">
                     <div class="small-note" v-if="form.accountPlan=='free'"><span>Bookblock HUB ON DEMAND:</span> Pay as you go for on demand Marketplace sends. You can always upgrade to Bookblock HUB Pro after you sign up.</div>
                     <div class="small-note" v-if="form.accountPlan=='pro'"><span>Bookblock HUB PRO:</span> Bookblock HUB represantive will get in touch with you to arrange pricing and finalise your onboarding. You will have access to all ON DEMAND functionality in the meantime.</div>
                 </div>
             </div>
        </div>
        
        <div v-if="step=='form-pro'" class="large-form" id="worksends-registration-step-3">
            <div class="form-line">
                <div class="form-field">
                    <label for="phone-number">Your Phone Number</label>
                    <input id="phone-number" v-model="form.phone" type="phone" required>
                </div>
            </div>
            
            <div class="form-line">
                <div class="form-field" style="width: 100%; max-width: 200px;" >
                    <label for="team-size">Expected Team Size</label>
                    <select id="team-size" v-model="form.size" >
                        <option v-for="index in 9" :value="index">{{ index }} {{ index==1?'person':'members'}}</option>
                        <option value="more">10+ members</option>
                    </select>
                </div>
                <div class="form-field" style="width: 50%" v-if="form.size == 'more'">
                    <label>&nbsp;</label>
                    <input v-model="form.sizeOther" type="number" placeholder="Please specify...">
                </div>
                
             </div>
             
            <div class="form-line">
                <div class="form-field form-field-checkbox">
                    <label>Types of Campaigns You Are Interested In</label>
                    <div class="form-field-grid-2-row">
                        <div class="checkbox-option">
                            <input id="generating-sales" v-model="form.targetUse" type="checkbox" value="Generating Sales">
                            <label for="generating-sales" class="checkbox-label">Generating Sales</label>
                        </div>
                        <div class="checkbox-option">
                            <input id="getting-survey-results" v-model="form.targetUse" type="checkbox" value="Getting Survey Results">
                            <label for="getting-survey-results" class="checkbox-label">Getting Survey Results</label>
                        </div>
                        <div class="checkbox-option">
                            <input id="collecting-reviews" v-model="form.targetUse" type="checkbox" value="Collecting Reviews">
                            <label for="collecting-reviews" class="checkbox-label">Collecting Reviews</label>
                        </div>
                        <div class="checkbox-option">
                            <input id="building-your-audience" v-model="form.targetUse" type="checkbox" value="Building Your Audience">
                            <label for="building-your-audience" class="checkbox-label">Building Your Audience</label>
                        </div>
                        <div class="checkbox-option">
                            <input id="corporate-gifting" v-model="form.targetUse" type="checkbox" value="Corporate Gifting">
                            <label for="corporate-gifting" class="checkbox-label">Corporate Gifting</label>
                        </div>
                        <div class="checkbox-option">
                            <input id="company-onboarding" v-model="form.targetUse" type="checkbox" value="Company Onboarding">
                            <label for="company-onboarding" class="checkbox-label">Company Onboarding</label>
                        </div>
                    </div>
                </div>
             </div>
             
             <div class="form-line">
                 <div class="form-field form-field-radio">
                     <label>Are You Interested Bespoke Branded Gifts</label>
                     <div class="form-field-grid-2-row">
                         <div class="radio-option">
                             <input id="branded-gifts-true" v-model="form.brandedGifts" type="radio" value="yes">
                             <label for="branded-gifts-true" class="checkbox-label">Yes</label>
                         </div>
                         <div class="radio-option">
                             <input id="branded-gifts-false" v-model="form.brandedGifts" type="radio" value="no">
                             <label for="branded-gifts-false" class="checkbox-label">No</label>
                         </div>
                     </div>
                     <div>Please indicate if you are interested in bespoke branded gifts for your campaigns. These gifts can be hosted in our warehouses.</div>
                 </div>
              </div>
             
             <div class="form-line" v-if="demo.isDemo || !team.id">
                <div class="form-field">
                    <label>How Did You Hear About Us?</label>
                    <select v-model="form.reference" required>
                        <option value="">-- Please choose one option --</option>
                        <option value="Google">Google / Internet Search</option>
                        <option value="Social Media">Social Media</option>
                        <option value="Bookblock HUB Contact">Contacted By Bookblock HUB Representative</option>
                        <option value="Personal Reference">Personal Reference</option>
                        <option value="Other">Other</option>
                    </select>
                </div>
                <div class="form-field" v-if="form.reference == 'Other'">
                    <input v-model="form.referenceOther" placeholder="Please specify...">
                </div>
             </div>

			 <div class="modal-errors">
                 <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
             </div>
             
             <div class="modal-errors">
                 <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
             </div>
             
             <div class="form-line">
                 <div class="form-field">
                     <div class="small-note"><span>Bookblock HUB PRO:</span> Filling out this additional information will get you activated and onboarded faster.</div>
                 </div>
             </div>
        </div>
        
        <!-- Order Prgcessing -->
        <div v-else-if="step == 'processing'">
            <div class="ws-form-processing"><div class="value-loader"></div><p>We are processing your registration. <br>Please give us a moment...</p></div>
        </div>
        
        <!-- Upgrade Request Done -->
        <div v-else-if="step == 'upgrade-done'">
            <div class="ws-form-processing">
                <p><b>We have successfully processed your request to upgrade your plan to Bookblock HUB Pro.</b></p>
                <p>Your new Bookblock HUB Account Manager will get in touch with you soon to finalise your upgrade.</p>
                <p>Thank you!</p>
            </div>
        </div>
        
        <!-- Already on Trial -->
        <div v-else-if="step == 'trial-pending'">
            <div class="ws-form-processing">
                <div v-if="!demo.isDemo && $store.state.proBlockMessage" class="small-note warning" style="max-width: 470px"><span>NOTE:</span> <b>{{ $store.state.proBlockMessage }}</b> is only available with <b>Bookblock HUB Pro</b> plan.</div>

                <p><b>We have received your request for Bookblock HUB Pro and it's being processed. A Bookblock HUB Account Manager will be in touch soon.</b></b>
                <p>In the meantime you can still enjoy <i>ON DEMAND</i> benefits of sending <a href="/pro/marketplace/">physical gifts</a> from our Marketplace as you want.</p>
                <p>If you have any issues, please <a href="#" @click.prevent="openContactModal">contact us</a>.</p>
            </div>
        </div>
        
        <!-- Already Pro (shouldn't be accessible, just in case) -->
        <div v-else-if="step == 'already-pro'">
            <div class="ws-form-processing">
                <p><b>It looks like you are already on the Bookblock HUB Pro plan.</b>
                <p>You should have access to all Bookblock HUB features. If you have any issues, please <a href="#" @click.prevent="openContactModal">contact us</a>.</p>
            </div>
        </div>

        <div v-if="step !== 'start'" class="form-actions">
            <span v-if="step=='form'" class="ws-button ws-button-secondary" @click="goToStart">Go Back</span>
            <span v-if="step=='form' && form.accountPlan=='trial'" class="ws-button ws-button-main" @click="goToProForm">Continue to Last Step</span>
            <span v-if="step=='form-pro'" class="ws-button ws-button-secondary" @click="step = 'form'">Go Back</span>
            <span v-if="step=='form-pro' && (demo.isDemo || !team.id)" class="ws-button ws-button-main" @click="submitRegistration">Create Bookblock HUB PRO Account</span>
            <span v-else-if="step=='form-pro'" class="ws-button ws-button-main" @click="submitRegistration">Upgrade To Bookblock HUB PRO</span>
            <span v-if="step=='form' && form.accountPlan=='free'" class="ws-button ws-button-main" @click="submitRegistration">Create ON DEMAND Account</span>
            <span v-if="['upgrade-done','trial-pending','already-pro'].includes(this.step)" class="ws-button ws-button-secondary" @click="closeRegistrationModal">CLOSE</span>
        </div>  
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "RegistrationModal",
    components: {Modal},
    data() {
        return {
            form: {
                teamId: '',
                accountPlan: '', 
                name: '',
                email: '',
                phone: '', 
                teamName: '', 
                password: '', 
                passwordConfirm: '', 
                size: '', 
                sizeOther: '',
                targetUse: [], 
                brandedGifts: 'yes',
                reference: '', 
                referenceOther: ''
            },
            step: 'start',
            lastStep: '',
            errors: {},
            response: {},
            modalWidth: 780,
        }
    },
    methods: {
        registrationValidateFields() {
            let fieldsToValidate = [];
            if (this.step == 'form') {
                fieldsToValidate = [
                    { name: 'Name', value: this.form.name, rules: ['required'] },
                    { name: 'Team Name', value: this.form.teamName, rules: ['required'] },
                    { name: 'Email', value: this.form.email, rules: ['required', 'email'] },
                    { name: 'Password', value: this.form.password, rules: ['required', 'minLength:6']},
                    { name: 'Password confirmation', value: this.form.passwordConfirm, rules: ['minLengthIf:6', ['mustMatch', this.form.password]]},
                ];
            } else if (this.step == 'form-pro') {
                fieldsToValidate = [
                    { name: 'Phone Number', value: this.form.phone, rules: ['required'] },
                    { name: 'Team Size', value: this.form.size, rules: ['required'] },
                ];
            }
            if (!fieldsToValidate.length) return true;
            
            this.errors = this.validateFields(fieldsToValidate);
            if (Object.keys(this.errors).length) return false;
            else return true;
        },
        async submitRegistration(action) {
            if (!this.registrationValidateFields()) {
				/* if (Object.keys(this.errors).length) {
					for (let [name, error] of Object.entries(this.errors)) {
						let selector = name.toLowerCase().replaceAll(' ', '-');
						let el = document.querySelector(`#${selector}`);
						if (el != null) document.querySelector(`#${selector}`).classList.add('error');
					}
				} */
				return;
			}
            
            this.lastStep = this.step;
            this.step = 'processing';

            if (this.form.size == 'more' && this.form.sizeOther) this.form.size = this.form.sizeOther;
            if (this.form.reference == 'Other' && this.form.referenceOther) this.form.reference = this.form.referenceOther;
            
            delete this.form.sizeOther;
            delete this.form.referenceOther;
            if (this.form.accountPlan == 'free') {
                delete this.form.phone;
                delete this.form.size;
                delete this.form.targetUse;
                delete this.form.brandedGifts;
            }
            
            try {
                if (this.demo.isDemo || !this.team.plan) {
                    await this.dispatchWaitAndNotify('teamSignUpToBookblockHub', this.form);
                    await this.$store.dispatch('onLogout');
                    window.location.href = "/pro/login?signup=success";
                } else if (this.team.plan != 'pro') {
                    await this.dispatchWaitAndNotify('upgradeToBookblockHubPro', this.form);
                    this.step = 'upgrade-done';
                } else {
                    this.notifyStatus('error', null, null, 'It seems that you are already signed in.');
                    this.step = this.lastStep;
                }
            } catch (e) {
                this.step = this.lastStep;
            }
        },
        goToStart() {
            this.modalWidth = 780;
            this.step = 'start';
        },
        goToProForm() {
            if (!this.registrationValidateFields()) return;
            this.step = 'form-pro';
        },
        chooseAccountPlan(plan) {
            this.form.accountPlan = plan;
            if (!this.demo.isDemo && this.team.id) {
                this.form.teamId = this.team.id;
                this.step = 'form-pro';
            }
            else this.step = 'form';
            this.modalWidth = 460;
        },
        closeRegistrationModal() {
            this.modals.registrationModal = false;
        },
        openContactModal() {
            this.$store.state.contactModalConfig.location = 'app';
            this.$store.state.contactModalConfig.subject = 'pro-upgrade';
            this.modals.registrationModal = false;
			this.modals.contactModal = true;
		},
    },
    mounted() {
        if (this.team.plan == 'trial') {
            this.modalWidth = 460;
            this.step = 'trial-pending';
        }
        if (!this.demo.isDemo && this.team.plan == 'pro') {
            this.modalWidth = 460;
            this.step = 'already-pro';
        }
    },
    computed: {
        user() {
            return this.$store.state.currentUser;
        },
        team() {
            return this.$store.state.team.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
        data() {
            return this.$store.state.contactModalConfig;
        },
        options() {
            return this.$store.state.contactModalOptions;
        },
        demo() {
            return this.$store.state.demo;
        }
    },
}
</script>